export default "__VITE_ASSET__Bey2pkb9__"